import { render, staticRenderFns } from "./ModalEditProductores.vue?vue&type=template&id=4980f12c&"
import script from "./ModalEditProductores.vue?vue&type=script&lang=js&"
export * from "./ModalEditProductores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports